import React, {useState} from 'react';
import {SmileOutlined} from '@ant-design/icons';
import {
    Form,
    Input,
    Button,
    Alert,
    Typography,
    Collapse,
    notification,
    Checkbox,
    Radio,
    Space,
} from 'antd';
import axios from "axios";
import {API_URI} from "../../constant/Config";
import {t} from '../../constant/i18n';

const {Panel} = Collapse;
const {TextArea} = Input;
const {Title, Text} = Typography;


class OrderFlightNoNecessary extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            dataCmd: this.props.dataCmd,
            filghtType: this.props.filghtType,
            libTexte: false,
            datasLoad: false,
            checkboxVolInfo: false,
            colSqlCheckbox: false,
            openColspace: [],
        }
    }

    async componentDidMount() {


        if (this.state.filghtType === 0) {
            // vol aller
            this.state.libTexte = {
                'header': t('orderFlight.outboundHeader'),
                'infos': t('orderFlight.importantInfo'),
                'motifData': this.props.dataCmd.volsInfos.getVolAllerNonNecessaireMotif,
                'sousinfos': t('orderFlight.contactBeforeBuy'),
                'motifTtre': t('orderFlight.outboundReasonTitle'),
                'motif1': t('orderFlight.outboundReason1'),
                'motif2': t('orderFlight.outboundReason2'),
                'motif3': t('orderFlight.outboundReason3'),
                'motifSelect': this.props.dataCmd.volsInfos.getVolAllerNonNecessaireMotifSelect,
            }
            await this.setState({colSqlCheckbox: this.props.dataCmd.volsInfos.getVolAllerNonNecessaire});


        } else if (this.state.filghtType === 1) {
            //vol retour
            this.state.libTexte = {
                'header': t('orderFlight.returnHeader'),
                'infos': t('orderFlight.importantInfo'),
                'motifData': this.props.dataCmd.volsInfos.getVolRetourNonNecessaireMotif,
                'sousinfos': t('orderFlight.contactBeforeBuy'),
                'motifTtre': t('orderFlight.returnReasonTitle'),
                'motif1': t('orderFlight.returnReason1'),
                'motif2': t('orderFlight.returnReason2'),
                'motif3': t('orderFlight.returnReason3'),
                'motifSelect': this.props.dataCmd.volsInfos.getVolRetourNonNecessaireMotifSelect,
            }
            await this.setState({colSqlCheckbox: this.props.dataCmd.volsInfos.getVolRetourNonNecessaire});
        }




        await console.log(this.state.colSqlCheckbox)

        if (this.state.colSqlCheckbox == '1') {
            await this.setState({
                checkboxVolInfo: true,
                openColspace : ['1'],
            })
        }

        await this.setState({datasLoad: true})
    }


    sendForm = async values => {
        var token = localStorage.getItem('membre_token');
        await axios.post(API_URI + '/api_member/flightmotif', {
            id: this.state.dataCmd.data.id,
            motif: values.motif,
            motifSelect: values.motifSelect,
            action: 'update',
            typeVol: this.state.filghtType,
        }, {
            headers: {
                'Authorization': token
            }
        });

        notification.open({
            message: t('orderFlight.reasonUpdated'),
            description: t('orderFlight.reasonUpdatedDesc'),
            icon: <SmileOutlined style={{color: '#108ee9'}}/>,
        });
    }

    sendFormCancel = async () => {
        var token = localStorage.getItem('membre_token');
        await axios.post(API_URI + '/api_member/flightmotif', {
            id: this.state.dataCmd.data.id,
            action: 'cancel',
            typeVol: this.state.filghtType,
        }, {
            headers: {
                'Authorization': token
            }
        });

        notification.open({
            message: t('orderFlight.reasonCancelled'),
            description: t('orderFlight.reasonCancelledDesc'),
            icon: <SmileOutlined style={{color: '#108ee9'}}/>,
        });
    }

    getFormFull = () => {
        return <>
            <Form
                labelCol={{
                    span: 18,
                }}
                wrapperCol={{
                    span: 14,
                }}
                layout="vertical"
                initialValues={{
                    motifSelect: this.state.libTexte.motifSelect, // Définir la valeur initiale pour le champ radio
                    motif: this.state.libTexte.motifData,
                }}
                onFinish={this.sendForm}
            >

                <Form.Item
                    label={this.state.libTexte.motifTtre}
                    name="motifSelect"
                    rules={[{ required: true, message: t('orderFlight.selectReason') }]}
                >
                    <Radio.Group>
                        <Space direction="vertical">
                            <Radio value="1"> {this.state.libTexte.motif1} </Radio>
                            <Radio value="2"> {this.state.libTexte.motif2} </Radio>
                            <Radio value="3"> {this.state.libTexte.motif3} </Radio>
                        </Space>
                    </Radio.Group>
                </Form.Item>

                <Form.Item
                    label={t('orderFlight.giveDetails')}
                    name={['motif']}

                >
                    <TextArea rows={4}/>
                </Form.Item>

                <Form.Item>
                    <Button htmlType="submit" type="primary">{t('common.validate')}</Button> <Button danger
                                                                                      onClick={this.sendFormCancel}>{t('orderFlight.cancelMyReason')}</Button>
                </Form.Item>
            </Form>
        </>
    }

    onChangeInfosVolRetourAller = async (key) => {
        if (key.length == 0) {
            this.setState({
                checkboxVolInfo: false,
            });
            await this.sendFormCancel();
        } else if (key.length == 1) {
            this.setState({
                checkboxVolInfo: true,
            })
        }
    }

    render() {

        return (
            <>
                <Title level={3}>{t('orderFlight.additionalInfo')}</Title>
                <Alert
                    message={this.state.libTexte.infos}
                    description={this.state.libTexte.sousinfos}
                    type="info"
                    showIcon
                />
                <br/>
                <Collapse defaultActiveKey={this.state.openColspace} onChange={this.onChangeInfosVolRetourAller}>
                    <Panel header={<div><Checkbox
                        checked={this.state.checkboxVolInfo}></Checkbox> {this.state.libTexte.header}</div>}
                           key="1">
                        <div>

                            {this.state.datasLoad ? this.getFormFull() : ''}

                        </div>
                    </Panel>
                </Collapse>
            </>
        )
    }
}

export default OrderFlightNoNecessary;